import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { mdiArrowLeft } from '@mdi/js'
import { useCloned } from '@vueuse/core'
import store from '@/store'
import SettingsProfile from '@/pages/ProfileSetting/ui/SettingsProfile.vue'
import SettingsSocial from '@/pages/ProfileSetting/ui/SettingsSocial.vue'
import SettingsPrivacy from '@/pages/ProfileSetting/ui/SettingsPrivacy.vue'
import SettingsPassword from '@/pages/ProfileSetting/ui/SettingsPassword.vue'
import SettingsOtherProfiles from '@/pages/ProfileSetting/ui/SettingsOtherProfiles.vue'
import { userApi } from '@/enitites/user'
import { ProfileSettingsLogoutButton } from '@/features/authorization'

type SettingsComponent =
  | typeof SettingsProfile
  | typeof SettingsSocial
  | typeof SettingsPrivacy
  | typeof SettingsPassword
  | typeof SettingsOtherProfiles


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSetting',
  setup(__props) {

const settingsComponents: Record<string, SettingsComponent> = {
  SettingsProfile,
  SettingsSocial,
  SettingsPrivacy,
  SettingsPassword,
  SettingsOtherProfiles,
}

const currentForm = ref<SettingsComponent>(SettingsProfile)
const loading = ref(false)
const mobileMenuHidden = computed(() => store.state.mobileMenuHidden)

const getUserDB = computed(() => store.getters.getUserDB)
const userForChange = ref(useCloned(getUserDB.value).cloned)

function setComponents(
  name: 'SettingsProfile' | 'SettingsSocial' | 'SettingsPrivacy' | 'SettingsPassword' | 'SettingsOtherProfiles'
) {
  store.commit('TOGGLE_MENU_MOBILE')
  currentForm.value = settingsComponents[name]
}

async function saveChanges() {
  loading.value = true

  const updatedUser = await userApi.updateUser(userForChange.value)
  loading.value = false
  if (!updatedUser) return

  await store.dispatch('setUserDB', userForChange.value)
  await store.dispatch('showAlertToast', 'changesSaved')
}

return { __sfc: true,settingsComponents, currentForm, loading, mobileMenuHidden, getUserDB, userForChange, setComponents, saveChanges, mdiArrowLeft, ProfileSettingsLogoutButton }
}

})